(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hoco-limited-products"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.hoco-limited').forEach(section=>{
const track=section.querySelector('.hoco-limited-track');
const move=direction=>{const card=track.querySelector('.hoco-limited-card');if(!card)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})};
section.querySelector('[data-limited-prev]').addEventListener('click',()=>move(-1));
section.querySelector('[data-limited-next]').addEventListener('click',()=>move(1));
});
  } catch(e) { console.error(e); }
})();

})();
